import React, { useState } from 'react';
import { useMessages } from '../../common/withMessages';
import { useModerateComment } from './withModerateComment'
import { DialogActions } from '@/components/widgets/DialogActions';
import { DialogContent } from '../../widgets/DialogContent';
import { DialogTitle } from '../../widgets/DialogTitle';
import Button from '@/lib/vendor/@material-ui/core/src/Button';
import TextField from '@/lib/vendor/@material-ui/core/src/TextField';
import LWDialog from "../../common/LWDialog";
import { useCurrentUser } from '../../common/withUser';
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles('DeleteCommentDialog', (theme: ThemeType) => ({
  subtitle: {
  },
  deleteWithoutTrace: {
    marginRight:"auto"
  },
  modalTextField: {
    marginTop: 10,
  },
}))

const DeleteCommentDialog = ({comment, onClose}: {
  comment: CommentsList,
  onClose?: () => void,
}) => {
  const classes = useStyles(styles);
  const [deletedReason, setDeletedReason] = useState("");
  const {moderateCommentMutation} = useModerateComment();
  const { flash } = useMessages();
  const currentUser = useCurrentUser();
  
  const isDeletingOwnComment = currentUser?._id === comment.userId;

  const handleDelete = (event: React.MouseEvent) => {
    event.preventDefault();
    void moderateCommentMutation({
      commentId: comment._id,
      deleted: true,
      deletedPublic: false,
      deletedReason: deletedReason,
    }).then(()=>{
      flash({messageString: "Successfully deleted comment", type: "success"})
      if (onClose)
        onClose();
    }).catch(/* error */);
  }

  const handleDeletePublic = (event: React.MouseEvent) => {

    event.preventDefault();
    void moderateCommentMutation({
      commentId: comment._id,
      deleted: true,
      deletedPublic: true,
      deletedReason: deletedReason,
    }).then(()=>{
      flash({messageString: "Successfully deleted comment", type: "success"})
      if (onClose)
        onClose();
    }).catch(/* error */);
  }

  const render = () => {
    return (
      <LWDialog open={true} onClose={onClose}>
        <DialogTitle>
          What is your reason for deleting this comment?
        </DialogTitle>
        <DialogContent>
          <p className={classes.subtitle}><em>
            {isDeletingOwnComment ? (
              "(If you delete publicly, the reason will be displayed below the comment. If you delete without a trace, the comment will be removed without any public indication.)"
            ) : (
              "(If you delete without a trace, the reason will be sent to the author of the comment privately. Otherwise it will be publicly displayed below the comment.)"
            )}
          </em></p>
          <br/>
          <TextField
            id="comment-menu-item-delete-reason"
            label="Reason for deleting (optional)"
            className={classes.modalTextField}
            value={deletedReason}
            onChange={(event) => setDeletedReason(event.target.value)}
            fullWidth
            multiline
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} className={classes.deleteWithoutTrace}>
            Delete Without Trace
          </Button>
          <Button onClick={onClose}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleDeletePublic}>
            Delete
          </Button>
        </DialogActions>
      </LWDialog>
    )
  }
  return render();
}

export default DeleteCommentDialog;


